import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { useNavigate } from 'react-router-dom';
import { OTP_AUTH_LOGIN } from '../../redux/actions';
import { CTA, CustomInput, Logo, Text } from '../../../ui/atoms';
import { RegexpType, validator } from '../../../utils/validator';
import routes from '../../../routes';
import {
  AuthContainer,
  FormContainer,
  InputWrapper,
  LogoContainer,
} from '../Auth/styles';
import { Container } from '../../../ui/gridSystem';
import { withMediaQueries } from '../../hoc/withMediaQueries';

const otpLength = 6;

const AuthOTP = ({
  mediaIsPhone,
  startLogin,
  appConfig,
  error,
  resetOTPError,
}) => {
  const navigate = useNavigate();
  const [otp, setOtp] = useState('');

  const handleOnChange = (newValue) => {
    setOtp(newValue);
  };

  const otpValid = () => validator(RegexpType.OTP, otp, true);

  const onKeyPress = (event) => {
    if (event.key === 'Enter' && otpValid()) {
      event.preventDefault();
      startLogin(otp, navigate);
    }
  };

  useEffect(() => {
    return () => resetOTPError();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AuthContainer>
      <FormContainer>
        <LogoContainer onClick={() => navigate(routes.auth.path)}>
          <Logo
            src={appConfig?.login_logo?.src}
            alt={appConfig?.login_logo?.alt}
            size={Logo.SIZE.XL}
          />
        </LogoContainer>
        <Container className="pt-0">
          <Text type="h2">Inserisci il codice OTP che ti abbiamo inviato</Text>
          <InputWrapper>
            <Text type="h3" mb={8}>
              Codice OTP
            </Text>
            <CustomInput
              placeholder="Codice OTP"
              onChange={(newValue) => handleOnChange(newValue)}
              onKeyPress={onKeyPress}
              value={otp}
              valid={!otp || otpValid()}
              error={`Il codice OTP deve contenere ${otpLength} caratteri`}
            />
          </InputWrapper>
          <InputWrapper className="btns-wrapper">
            <CTA
              fullsize={mediaIsPhone}
              btnText="Login"
              disabled={!otpValid()}
              onClick={() => {
                if (otpValid()) startLogin(otp, navigate);
              }}
            />
            {error && (
              <CTA
                type="secondary"
                btnText="Torna alla login"
                onClick={() => navigate(routes.auth.path)}
              />
            )}
          </InputWrapper>
        </Container>
      </FormContainer>
    </AuthContainer>
  );
};

AuthOTP.propTypes = {
  mediaIsPhone: PropTypes.bool,
  appConfig: PropTypes.object,
  error: PropTypes.string,
  // HOC (connect, dispatch)
  startLogin: PropTypes.func.isRequired,
  resetOTPError: PropTypes.func.isRequired,
};

export default connect(
  (state) => {
    const {
      appConfig,
      authState: { error },
    } = state.app;
    return { appConfig, error };
  },
  (dispatch) => ({
    startLogin: (otp, navigate) =>
      dispatch({ type: OTP_AUTH_LOGIN._REQUEST, otp, navigate }),
    resetOTPError: () =>
      dispatch({ type: OTP_AUTH_LOGIN._ERROR, response: '' }),
  })
)(withMediaQueries(AuthOTP));
